var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, useRecipe } from "@chakra-ui/react";
import { formatSince } from "@/components/utils";
import { JobBadges } from "./JobBadges";
export var SearchResultsListItemDetails = function (_a) {
    var job = _a.job;
    var recipe = useRecipe({ key: "SearchResultsListItemDetails" });
    var styles = recipe();
    return (_jsxs(Box, __assign({ css: styles }, { children: [_jsx(Text, __assign({ variant: "listingTitle", as: "h2" }, { children: job.title })), _jsx(Text, __assign({ variant: "listingCompany" }, { children: job.company })), _jsx(Text, __assign({ variant: "listingLocation" }, { children: job.location })), _jsx(JobBadges, { job: job }), _jsxs(Text, __assign({ variant: "postedAt" }, { children: ["Posted ", formatSince(job.datePublished)] }))] })));
};
